/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

// ========= module component import section ========= //
import { Modal } from 'reactstrap';
import _ from 'lodash';
import { IconContext } from 'react-icons';
import { BsArrowRight, BsCheck } from 'react-icons/bs';
// ====== end of module component import section ====== //

// ========= project component import section ========= //
import { emptyImage, getCloudImageUrl, formatCurrency } from '../../../utils';
import {
  accessoriesCondition,
  boxCondition,
  boxHandbag,
  convertToRupiah,
  dustBag,
  handbagCondition,
  sneakersCondition,
  yellowing,
  displayItem,
  sneakersDefect as sneakerDefect,
  sneakerDefectsCondition,
} from '../../../utils/Helpers';
import {
  MANDIRI_CREDIT_CARD,
  MANDIRI_DEBIT_CARD,
  CREDITCARD,
  INSTALLMENTS,
  BCA_INSTALLMENTS,
  BANKTRANSFER,
  MANDIRI_VA,
  BCA_VA,
  PERMATA_VA,
  BNI_VA,
  BRI_VA,
  VIRTUALACCOUNT,
  FULLWALLET,
  KICK_POINT,
  BCA_CREDIT_CARD,
  BNI_CREDIT_CARD,
  BNI_DEBIT_CARD,
  BCA_KLIK_PAY,
  BCA_ONEKLIK,
  AKULAKU,
  ATOME,
  GOPAY,
  KREDIVO,
} from '../../../constants/paymentMethods';
// ====== end of project component import section ====== //

// ========= action import section ========= //
// ====== end of action import section ====== //

// ========= interface import section ========= //
import { ProgressDetailData } from '../BuyingTabs/InProgress';
import {
  doBuyCompletions,
  fetchShippingTracking,
} from '../../../actions/dashboardAction';
import ModalShippingTracking from './ModalShippingTracking';
import { GrClose } from 'react-icons/gr';
import { UserCurrencyInterface } from '../../../interface/reducers/auth';
// ====== end of interface import section ====== //

const handlePaymentMethodText = (item: string) => {
  let firstText = '';
  let secondtext = '';

  switch (item) {
    case MANDIRI_CREDIT_CARD:
      firstText = 'MANDIRI Credit Card';
      secondtext = '';
      break;
    case MANDIRI_DEBIT_CARD:
      firstText = 'MANDIRI Debit Card';
      secondtext = '';
      break;
    case CREDITCARD:
    case INSTALLMENTS:
      firstText = '';
      secondtext = 'Credit / Debit Card';
      break;
    case BCA_INSTALLMENTS:
      firstText = 'BCA Installments';
      secondtext = '';
      break;
    case BANKTRANSFER:
      firstText = 'Bank Transfer';
      secondtext = '';
      break;
    case MANDIRI_VA:
      firstText = 'MANDIRI';
      secondtext = 'Virtual Account';
      break;
    case BCA_VA:
      firstText = 'BCA';
      secondtext = 'Virtual Account';
      break;
    case PERMATA_VA:
      firstText = 'PERMATA';
      secondtext = 'Virtual Account';
      break;
    case BNI_VA:
      firstText = 'BNI';
      secondtext = 'Virtual Account';
      break;
    case BRI_VA:
      firstText = 'BRI';
      secondtext = 'Virtual Account';
      break;
    case GOPAY:
      firstText = 'GOPAY';
      secondtext = '';
      break;
    case VIRTUALACCOUNT:
      firstText = 'Other Virtual Account';
      secondtext = '';
      break;
    case FULLWALLET:
      firstText = 'Full Wallet';
      secondtext = '';
      break;
    case KICK_POINT:
      firstText = 'Kick Point';
      secondtext = '';
      break;
    case BCA_CREDIT_CARD:
      firstText = 'BCA Credit Card / Debit Card';
      secondtext = '';
      break;
    case BNI_CREDIT_CARD:
      firstText = 'BNI Credit Card';
      secondtext = '';
      break;
    case BNI_DEBIT_CARD:
      firstText = 'BNI Debit Card';
      secondtext = '';
      break;
    case KREDIVO:
      firstText = 'Kredivo';
      secondtext = '';
      break;
    case ATOME:
      firstText = 'Atome';
      secondtext = '';
      break;
    case AKULAKU:
      firstText = 'Akulaku';
      secondtext = '';
      break;
    case BCA_KLIK_PAY:
      firstText = 'BCA';
      secondtext = 'Klik Play';
      break;
    case BCA_ONEKLIK:
      firstText = 'BCA';
      secondtext = 'One Klik';
      break;
    default:
      firstText = '';
      secondtext = '';
      break;
  }
  return secondtext + ' ' + firstText;
};

type stateToProps = {
  doFetchShippingTracking: (saleId: number) => Promise<any>;
  doCompleteShipping: (saleId: number) => Promise<any>;
};

interface ModalInProgress extends stateToProps {
  isOpen: boolean;
  onToggle: () => any;
  data: ProgressDetailData;
  currency: UserCurrencyInterface;
  callback: () => void;
}

/**
 * Modal for Buying Pending Detail on User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {ModalInProgress} props for this component.
 * @return {JSX.Element}
 */
function ModalInProgressComponent({
  isOpen,
  onToggle,
  data,
  currency,
  callback,
  doFetchShippingTracking,
  doCompleteShipping,
}: ModalInProgress): JSX.Element {
  const [isModalTrackingVisible, setModalTrackingVisible] = useState(false);
  const [modalTrackingData, setModalTrackingData] = useState(data.trackingData);

  const toggleModalTracking = () =>
    setModalTrackingVisible(!isModalTrackingVisible);

  useEffect(() => {
    if (data && data.trackingData) setModalTrackingData(data.trackingData);
  }, [data]);

  useEffect(() => {
    if (isModalTrackingVisible) {
      doFetchShippingTracking(modalTrackingData.saleId);
    }
  }, [isModalTrackingVisible]);

  const received = () => {
    doCompleteShipping(modalTrackingData.saleId).then(() => {
      onToggle();
      callback();
    });
  };

  // If data is available, then show the modal
  if (data.totalAmount) {
    const {
      imageUrl,
      category,
      sneakersDefect,
      defects,
      displayName,
      SKU,
      size,
      isVintage,
      invoiceNumber,
      shipping,
      paymentMethod,
      saleStatus,
      totalAmount,
      kickPoints,
      sellerCredit,
      kickCredit,
      hideBoxInfo,
      isTicket
    } = data;
    const isDefects = defects?.length > 0;
    const isDeliverying = saleStatus === 'Delivery to Customer';
    const uniqueDefects = _.uniqBy(isDefects ? defects : null, 'name');
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a) => a.name === 'DUST_BAG' && a.value)
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find((a) => a.name === 'BOX')
      : {};
    const sneakersDetailArr = [
      sneakersCondition(data.sneakersCondition),
      hideBoxInfo ? '' : boxCondition(data.boxCondition),
      accessoriesCondition(data.missingAccessories),
      yellowing(data.yellowing),
      displayItem(data.displayItem),
      sneakerDefect(data.sneakersDefect),
      isDefects ? sneakerDefectsCondition(uniqueDefects) : '',
    ];
    const sneakersDetail = sneakersDetailArr
      .filter((item) => item !== '')
      .map((items) => items)
      .join(' / ');
    const LuxuryArr = [
      sneakersCondition(data.sneakersCondition),
      accessoriesCondition(data.missingAccessories),
      dustBag(dustBagCondition),
      ,
      isDefects ? handbagCondition(uniqueDefects) : '',
    ];

    const LuxuryDetails = LuxuryArr.filter((item) => item !== '')
      .map((items) => items)
      .join(' / ');

    const isOnlyKickPoint = paymentMethod === KICK_POINT;
    const dataUserCurrency = isOnlyKickPoint
      ? {
          ...currency,
          currency: 'KP',
        }
      : currency;

    return (
      <Modal
        className="inprogress-detail-modal"
        toggle={onToggle}
        isOpen={isOpen}
        centered
      >
        <>
          <div className={'content-modal'}>
            <div className={'header-section'}>
              <div className={'left'}>
                <p className={'product-title'}>{displayName}</p>
                <p className={'product-sku'}>{SKU}</p>
              </div>
              <div className={'right'}>
                <div>
                  {category === 'handbags' ||
                  (category === 'lifestyles' &&
                    size.toLowerCase() !== 'all size') ? (
                    <div className={'size-container'}>
                      <p>{size}</p>
                    </div>
                  ) : (
                    <div className={'size-container'}>
                      <p>US {size}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={'image-section'}>
              <KickImage
                src={
                  imageUrl
                    ? getCloudImageUrl(imageUrl, 300)
                    : emptyImage(category)
                }
              />
            </div>
            <div className={'status-section'}>
              <p>{saleStatus}</p>
            </div>
            <div className={'product-detail-section'}>
              <div className={'product-detail-container'}>
                <p className={'title'}>Order ID</p>
                <p className={'value'}>{invoiceNumber}</p>
              </div>
              <div className={'product-detail-container'}>
                <p className={'title'}>Product Conditions</p>
                {
                  isTicket ?
                  <p className={'value'}>{sneakersCondition(data.sneakersCondition)}</p> : 
                  <p className={'value'}>
                    {isVintage
                      ? 'Vintage'
                      : category === 'handbags'
                      ? LuxuryDetails
                      : sneakersDetail}
                  </p>
                }
              </div>
              <div className={'product-detail-container'}>
                <p className={'title'}>Address</p>
                <p className={'value'}>
                  {shipping.alias + ' - ' + shipping.full_name}
                </p>
              </div>
              <div className={'product-detail-container'}>
                <p className={'title'}>Payment Method</p>
                <p className={'value'}>
                  {handlePaymentMethodText(paymentMethod)}
                </p>
              </div>
              {kickCredit && (
                <div className={'product-detail-container'}>
                  <p className={'title'}>Kick Credit</p>
                  <p className={'value'}>
                    {convertToRupiah(parseInt(kickCredit))}
                  </p>
                </div>
              )}
              {sellerCredit && (
                <div className={'product-detail-container'}>
                  <p className={'title'}>Seller Credit</p>
                  <p className={'value'}>
                    {convertToRupiah(parseInt(sellerCredit))}
                  </p>
                </div>
              )}
              {kickPoints && (
                <div className={'product-detail-container'}>
                  <p className={'title'}>Kick Points</p>
                  <p className={'value'}>
                    {convertToRupiah(parseInt(kickPoints))}
                  </p>
                </div>
              )}
              <div className={'product-detail-container no-mb'}>
                <p className={'title'}>Total Order</p>
                <p className={'value'}>
                  {formatCurrency(
                    totalAmount,
                    dataUserCurrency.ratio,
                    dataUserCurrency.currency,
                  )}
                  {/* IDR {convertToRupiah(totalAmount.toString().slice(0, -3))} */}
                </p>
              </div>
            </div>
            <div className={'info-section'}>
              <p>
                Please consistently check yout emails and notifications to
                receive any information regarding your package
              </p>
            </div>
            {isDeliverying && (
              <div className={'bottom-button-section'}>
                <div
                  className={'confirm-payment-button'}
                  onClick={toggleModalTracking}
                >
                  <p>Track your package</p>
                  <IconContext.Provider value={{ color: '#fff', size: '20px' }}>
                    <div>
                      <BsArrowRight />
                    </div>
                  </IconContext.Provider>
                </div>
                <div className={'confirm-payment-button'} onClick={received}>
                  <p>Package Received</p>
                  <IconContext.Provider value={{ color: '#fff', size: '20px' }}>
                    <div>
                      <BsCheck />
                    </div>
                  </IconContext.Provider>
                </div>
              </div>
            )}
          </div>
          <ModalShippingTracking
            data={data.trackingData}
            onToggle={toggleModalTracking}
            isOpen={isModalTrackingVisible}
            callback={callback}
            isDeliverying={isDeliverying}
            onToggleParent={onToggle}
          />
          <div className={'close-button'} onClick={onToggle}>
            <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
              <div>
                <GrClose />
              </div>
            </IconContext.Provider>
          </div>
        </>
      </Modal>
    );
  }
  // Not rendering the modal component is data is unavailable to prevent undefined error
  return <div />;
}

const mapStateToProps = (state: stateToProps) => {
  return {};
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doFetchShippingTracking: (saleId: number) =>
      dispatch(fetchShippingTracking(saleId)),
    doCompleteShipping: (saleId: number) => dispatch(doBuyCompletions(saleId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalInProgressComponent);
